module.exports = __webpack_public_path__ + "static/media/jpg.36dcc70f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/jpg.svg
// module id = 754
// module chunks = 17